import {lazy} from '@aboutyou/lazy-imports';
import {useCurrentPageType} from '@aboutyou/router';
import React from 'react';

const SearchResultQuestionnaireWidget = lazy(() =>
  import('./SearchResultQuestionnaire.eager').then(mod => ({
    default: mod.SearchResultQuestionnaire,
  })),
);

export const SearchResultQuestionnaire: React.FC = () => {
  const currentPageType = useCurrentPageType();

  if (
    !currentPageType ||
    !['category', 'brandShop', 'search', 'story'].includes(currentPageType)
  ) {
    return null;
  }

  return <SearchResultQuestionnaireWidget />;
};
